<div
  class="custom-radio-wrapper btn-group btn-group-toggle {{ hasOnlyText ? 'd-flex justify-content-center align-items-stretch' : '' }}"
  [id]="id"
  ngbRadioGroup
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.aria-describedby]="errorId"
  >
  @for (option of optionsList(); track option; let i = $index) {
    <label
      ngbButtonLabel
      class="btn-primary d-flex align-items-center justify-content-center custom-radio-label w-100"
      >
      <input ngbButton type="radio" [value]="option.value" [id]="id + '-' + i" />
      @if (option.icon) {
        <div class="d-flex justify-content-center align-items-center flex-column icon-wrapper">
          <div class="d-flex justify-content-center align-items-center flex-nowrap">
            @for (l of [].constructor(option.repeat || 1); track l) {
              <i class="fas fa-2x fa-{{ option.icon }}"></i>
            }
          </div>
          @if (option.icon && option.label) {
            <small class="icon-text" [ngClass]="{ 'sr-only': option.srOnly }" [attr.for]="id + '-' + i">
              {{ option.label }}
            </small>
          }
        </div>
      }
      @if (!option.icon && option.label) {
        <span class="radio-text" [attr.for]="id + '-' + i">
          {{ option.label }}
        </span>
      }
    </label>
  }
</div>
